import { useState, useEffect } from "react";
import { Box, Stack } from "@mui/material";
import ButtonComponent from "../atoms/ButtonComponent";
import InputLabel from "../atoms/InputLabel";
import stylesAgent from "../../styles/Molecules/Agents/styleAgents";
import useWexClient from "../../hooks/Clients/wexClient,";
import MuiModal from "../atoms/MuiModal";
import SwitchComponent from "../atoms/SwitchControler";
import AlertComponent from "../atoms/Alert";

function BasesFormModal({
  open = false,
  onClose,
  serviceId,
  forCreate = true,
  base = null,
  onSaved = () => {},
}) {
  const { createBase, updateBase } = useWexClient();
  const [alertMessage, setAlertMessage] = useState("");
  const [alertType, setAlertType] = useState("success");
  const [showAlert, setShowAlert] = useState(false);
  const [baseForm, setBaseForm] = useState({
    description: "",
    isConfirmed: false,
    coordinates: "",
    status: true,
  });

  useEffect(() => {
    if (open && base) {
      setBaseForm({
        description: base.description || "",
        isConfirmed: base.isConfirmed ?? false,
        coordinates: base.coordinates || "",
        status: base.status ?? true,
      });
    } else if (!open) {
      setBaseForm({
        description: "",
        isConfirmed: false,
        coordinates: "",
        status: true,
      });
    }
  }, [open, base]);

  const newBase = async () => {
    const body = {
      serviceId,
      description: baseForm.description,
      isConfirmed: baseForm.isConfirmed,
      coordinates: baseForm.coordinates,
    };

    const response = await createBase(body);

    if (response?.success === true) {
      setAlertMessage(response.message);
      setAlertType("success");
      setShowAlert(true);
      onSaved?.();
      setTimeout(() => {
        setAlertMessage("");
        setAlertType("success");
        setShowAlert(false);
        onClose?.();
      }, 1500);
    } else {
      setAlertMessage(response.message || "Error al crear la base");
      setAlertType("error");
      setShowAlert(true);
    }
  };

  const updatedBase = async () => {
    const body = {
      baseId: base?._id,
      description: baseForm.description,
      coordinates: baseForm.coordinates,
      isConfirmed: baseForm.isConfirmed,
      status: baseForm.status,
    };

    const response = await updateBase(body);

    if (response?.success === true) {
      setAlertMessage(response.message);
      setAlertType("success");
      setShowAlert(true);
      onSaved?.();
      setTimeout(() => {
        setAlertMessage("");
        setAlertType("success");
        setShowAlert(false);
        onClose?.();
      }, 1500);
    } else {
      setAlertMessage(response.message || "Error al actualizar la base");
      setAlertType("error");
      setShowAlert(true);
    }
  };

  const deleteBase = async () => {
    const body = {
      baseId: base?._id,
      status: false,
    };

    const response = await updateBase(body);

    if (response?.success === true) {
      setAlertMessage(response.message);
      setAlertType("success");
      setShowAlert(true);
      onSaved?.();
      setTimeout(() => {
        setAlertMessage("");
        setAlertType("success");
        setShowAlert(false);
        onClose?.();
      }, 1500);
    } else {
      setAlertMessage(response.message || "Error al eliminar la base");
      setAlertType("error");
      setShowAlert(true);
    }
  };

  const handleSave = () => {
    if (forCreate) {
      newBase();
    } else {
      updatedBase();
    }
  };

  const Buttons = () => (
    <Stack direction="row" spacing={2} justifyContent="flex-end">
      <Stack style={stylesAgent.divButton}>
        <ButtonComponent
          backgroundColor="#9a2edb"
          label={"Cancelar"}
          onClick={onClose}
        />
      </Stack>

      {!forCreate && (
        <Stack style={stylesAgent.divButton}>
          <ButtonComponent
            backgroundColor="#d32f2f"
            label={"Eliminar"}
            onClick={deleteBase}
          />
        </Stack>
      )}
      <Stack style={stylesAgent.divButton}>
        <ButtonComponent
          backgroundColor={"#1976d2"}
          label={"Guardar"}
          onClick={handleSave}
        />
      </Stack>
    </Stack>
  );

  return (
    <MuiModal
      visible={open}
      onClose={onClose}
      title={forCreate ? "Nueva Base" : "Editar Base"}
      buttons={<Buttons />}
      width="500px"
      arrastrar={true}
    >
      {showAlert && (
        <AlertComponent
          message={alertMessage}
          typeAlert={alertType}
          handleClose={() => setShowAlert(false)}
        />
      )}
      <Box sx={{ display: "grid", gap: 2 }}>
        <InputLabel
          inputType="text"
          label="Descripción"
          value={baseForm.description}
          hdlOnChange={(val) =>
            setBaseForm((prev) => ({ ...prev, description: val }))
          }
        />
        <InputLabel
          inputType="text"
          label="Coordenadas"
          value={baseForm.coordinates}
          hdlOnChange={(val) =>
            setBaseForm((prev) => ({ ...prev, coordinates: val }))
          }
        />
        <Stack direction="row" spacing={2} justifyContent="flex-start">
          <SwitchComponent
            label="¿Base Confirmada?"
            checked={baseForm.isConfirmed}
            onChange={(e) =>
              setBaseForm((prev) => ({
                ...prev,
                isConfirmed: e.target ? e.target.checked : e,
              }))
            }
          />
        </Stack>
      </Box>
    </MuiModal>
  );
}

export default BasesFormModal;
